export const DESKTOP_MEDIA = '(min-width: 961px)';
export const STABLE = 'Stable';
export const MARBLE = 'Marble';
export const EMBARK = 'Embark';
